require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-zurndorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-zurndorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-zurndorf!./.cache/json/betreuungseinrichtungen-neusiedl-zurndorf.json
// module id = 969
// module chunks = 231608221292675